// Simple session store for DigiLocker session ID
let digilockerSessionId = null;

export const SessionStore = {
  setSessionId(id) {
    digilockerSessionId = id;
    localStorage.setItem('digilocker_session_id', id);
    console.log('SessionStore: Stored session ID:', id);
  },

  getSessionId() {
    if (!digilockerSessionId) {
      digilockerSessionId = localStorage.getItem('digilocker_session_id');
    }
    return digilockerSessionId;
  },

  clearSessionId() {
    digilockerSessionId = null;
    localStorage.removeItem('digilocker_session_id');
    console.log('SessionStore: Cleared session ID');
  }
};